class ReadMoreLines extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('button[aria-expanded]');
    this.button?.addEventListener('click', this.toggle);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
  }

  toggle() {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', String(!isExpanded));
  }
}

if (!customElements.get('read-more-lines')) {
  customElements.define('read-more-lines', ReadMoreLines);
}
